import { render, staticRenderFns } from "./NewArrivalsdetails.vue?vue&type=template&id=59105de0&scoped=true&"
import script from "./NewArrivalsdetails.vue?vue&type=script&lang=js&"
export * from "./NewArrivalsdetails.vue?vue&type=script&lang=js&"
import style0 from "./NewArrivalsdetails.vue?vue&type=style&index=0&id=59105de0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59105de0",
  null
  
)

export default component.exports